import { ReactElement } from 'react'
import { Route } from 'react-router-dom'
import { pages } from 'navigation/pages'
import { Roles } from '@Arti-zen/package-backoffice'
import { RouteProtected } from 'navigation/navigation.helper'
import SupportLayout from './SupportLayout'
import InvoiceQuotationMissingList from '../components/InvoiceQuotationMissingList'
import CompanyLastDocList from '../components/CompanyLastDocList/CompanyLastDocList'
import ImageResizer from '../components/ImageResizer'
import AccountSubcriptionDateMissing from '../components/AccountSubcriptionDateMissing'
import AccountResiliationDateMissing from '../components/AccountResiliationDateMissing'
import SubAccountNotSyncWithBossAccount from '../components/SubAccountNotSyncWithBossAccount'
import SubAccountNotSyncWithBossAccountDemo from '../components/SubAccountNotSyncWithBossAccountDemo'

export default function SupportRouter(): ReactElement {
  const supportPages = pages.connected.support

  return (
    <Route
      path={pages.connected.support.root}
      element={RouteProtected(<SupportLayout />, [Roles.SUPER_ADMIN, Roles.ADMIN])}
    >
      <Route path={supportPages.invoiceQuotationMissing.name} element={<InvoiceQuotationMissingList />} />
      <Route path={supportPages.companyLastDocs.name} element={<CompanyLastDocList />} />
      <Route path={supportPages.imageResizer.name} element={<ImageResizer />} />
      <Route
        path={supportPages.accountSubcriptionDateMissing.name}
        element={<AccountSubcriptionDateMissing />}
      />
      <Route
        path={supportPages.accountResiliationDateMissing.name}
        element={<AccountResiliationDateMissing />}
      />
      <Route path={supportPages.subAccountNotSyncWithBossAccount.name} element={<SubAccountNotSyncWithBossAccount />} />
      <Route path={supportPages.subAccountNotSyncWithBossAccountDemo.name} element={<SubAccountNotSyncWithBossAccountDemo />} />
    </Route>
  )
}
